import {
  Box,
  ButtonBase,
  SxProps,
  Theme,
  Typography,
  useTheme,
} from '@mui/material';
import { Link } from 'react-router-dom';
import EastRoundedIcon from '@mui/icons-material/EastRounded';
import Progress from '../../global/ProgressBar';
import useGetOnboarding from '../../../hooks/businesses/useGetOnboarding';
import { ROUTES } from '../../../constants/global';

interface Props {
  sx?: SxProps<Theme>;
}

function OnboardingProgress({ sx }: Props) {
  const theme = useTheme();
  const { isEnabled, isOnboardingComplete, isLoading, percentCompleted } =
    useGetOnboarding();

  if (!isEnabled || isLoading || isOnboardingComplete) return null;

  return (
    <ButtonBase
      component={Link}
      to={ROUTES.getStarted}
      disableRipple
      sx={{
        overflow: 'hidden',
        boxSizing: 'border-box',
        py: 2.5,
        ':hover': {
          backgroundColor: 'transparent',
        },
        ...(typeof sx === 'function' ? sx(theme) : sx),
      }}>
      <Box
        width="100%"
        boxSizing="border-box"
        display="flex"
        flexDirection={{
          xs: 'column',
          sm: 'row',
        }}
        justifyContent={{
          xs: 'center',
          sm: 'space-between',
        }}
        alignItems={{
          xs: 'stretch',
          sm: 'center',
        }}
        gap={{
          xs: 1,
          sm: 2.5,
        }}>
        <Typography
          variant="h1"
          component="p"
          textAlign="left"
          fontFamily={theme.typography.fontFamily}>
          You&apos;re {percentCompleted}% set up
        </Typography>

        <Box
          boxSizing="border-box"
          flex={1}
          maxWidth={{
            xs: '100%',
            sm: '33%',
            lg: '25%',
          }}
          display="flex"
          alignItems="center"
          gap={1}>
          <Progress progress={percentCompleted} includePercentage />
          <EastRoundedIcon
            htmlColor={theme.palette.secondary.main}
            sx={{
              width: '22px',
            }}
          />
        </Box>
      </Box>
    </ButtonBase>
  );
}

export default OnboardingProgress;
